<template>
	<div>
		<nav class="c-gallery__nav">
			<button @click="prev($event)" class="c-gallery__prev" :disabled="!hasPrev">
				<span class="h-accessibility">Previous slide</span>
				<span class="icon"><arrowLeft/></span>
			</button>
			<button @click="next($event)" class="c-gallery__next" :disabled="!hasNext">
				<span class="h-accessibility">Next slide</span>
				<span class="icon"><arrowRight/></span>
			</button>
		</nav>
		<slot name="heading"></slot>
		<vue-horizontal class="c-gallery__slides" responsive :button="false" ref="horizontal" @scroll-debounce="onScroll">
			<slot name="slides"></slot>
		</vue-horizontal>
	</div>
</template>

<script>
	// this gallery carousel merely adds flickity to a gallery of images produced in twig
	// it does not open a lightbox carousel or pull from api
	// that is gallery-button > lightbox-carousel OR gallery-thumbs > lightbox-carousel
	import VueHorizontal from "vue-horizontal";
	import arrowLeft from '/web/static/images/svgs/icon-arrow-left.svg?component';
	import arrowRight from '/web/static/images/svgs/icon-arrow-right.svg?component';

	export default {
		name: "v-gallery-carousel",
		components: {
			VueHorizontal,
			arrowLeft,
			arrowRight
		},
		data() {
			return {
				hasPrev: false,
				hasNext: true,
			}
		},
		props: {},
		methods: {
			prev(e) {
				this.$refs.horizontal.prev(e)
			},
			next(e) {
				this.$refs.horizontal.next(e)
			},
			onScroll({hasPrev, hasNext}) {
				this.hasPrev = hasPrev
				this.hasNext = hasNext
			}
		},
	};
</script>
